import printReportAction from '@/components/nsw-components/PrintReportsAction';
import DocumentNewVersionAction from '@/components/nsw-components/DocumentNewVersionAction';

export default {
	actions: [
		printReportAction.printReport('WASTE_NOTIFICATIONS', 'notificationid', 'reports.label.wasteNotification'),
		DocumentNewVersionAction.newVersion(null)
	]
};
